import { faCheckCircle, faXmarkCircle } from '@fortawesome/pro-solid-svg-icons'
import TwinIcon from '../../../../../baseComponents/TwinIcon'
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'
import { TwinDictionary } from '../../../../../utils/globals/dictionary'
import TwinToolTip from '../../../../../baseComponents/TwinToolTip'
import TwinTrans from '../../../../../baseComponents/TwinTrans'
import { GetOrderStatusBarTypeProps } from './types'
import './orderStatusBar.sass'

export interface OrderStatusBarProps {
    statuses: TwinDictionary[]
    currentOrderStatus: number
    getOrderStatusBarType: (params: GetOrderStatusBarTypeProps) => {
        type: string,
        isLast: boolean
    }
    isCanceled?: boolean
}

const OrderStatusBar: React.FC<OrderStatusBarProps> = ({ currentOrderStatus, statuses, getOrderStatusBarType, isCanceled }) => {
    const renderThis: JSX.Element[] = []
    const statusesLength = statuses.length
    let isCanceledBar = isCanceled || false
    for (const key in statuses) {
        const parsedKey = parseInt(key)
        const element = statuses[key]
        const elementNext = statuses[parsedKey + 1]
        const { type, isLast } = getOrderStatusBarType({ element, elementNext, isCanceledBar, parsedKey, currentOrderStatus, statusesLength })
        const MyItem = Components[type]
        renderThis.push(<MyItem name={element?.name} isLast={isLast} key={key} type={type} renderMessage={element.renderMessage} />)
    }
    return (
        <div className={'flex items-center order_status_bar ' + (isCanceledBar ? 'canceled_bar' : '')}>
            {renderThis}
        </div>
    )
}

interface SingleStatusItemProps {
    name: string
    isLast: boolean
    type: string
    isCanceledBar: boolean
    className?: string
    renderMessage: JSX.Element | null
}
interface SingleStatusItemParentProps extends SingleStatusItemProps {
    children: React.ReactNode
}

const SingleStatusItem: React.FC<SingleStatusItemParentProps> = ({ name, renderMessage, className, children }) => {
    return (
        <div className={'single_status_item flex items-center py-5 px-10 ' + (className || '') + (renderMessage ? ' cursor-default' : '')} data-tooltip-id={name}>
            {children}
            {renderMessage ?
                <TwinToolTip id={name} place='bottom'>
                    {renderMessage}
                </TwinToolTip>
                : null
            }
        </div>
    )
}

const SingleStatusItemActual: React.FC<SingleStatusItemProps> = ({ name, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <SingleStatusItem isLast={isLast} className={'actual_status ' + isLastClassName} name={name} {...rest}>
            <div className='flex items-center single_status_item_text'>
                <div className={'mr-5 rounded-full w-10 h-10 bg-blue-05'}></div>
                <span>{name}</span>
            </div>
        </SingleStatusItem>
    )
}

const SingleStatusItemActualLast: React.FC<SingleStatusItemProps> = ({ name, ...rest }) => {
    return (
        <SingleStatusItem className='last_actual_status' name={name} {...rest}>
            <div className='flex items-center single_status_item_text'>
                <TwinIcon icon={faCheckCircle} className='text-green-43 mr-5' />
                <span>{name}</span>
            </div>
        </SingleStatusItem>
    )
}

const SingleStatusItemFuture: React.FC<SingleStatusItemProps> = ({ name, type, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <SingleStatusItem isLast={isLast} type={type} className={'future_status ' + isLastClassName} name={name} {...rest} >
            <div className='flex items-center single_status_item_text'>
                <div className='mr-5 rounded-full w-10 h-10 bg-gray-D9'></div>
                <span className='text-gray-D9'>{name}</span>
            </div>
            {!isLast ?
                <TwinIcon className={'arrow_right ' + type} icon={faChevronRight} />
                : null
            }
        </SingleStatusItem>
    )
}

const SingleStatusItemCompleted: React.FC<SingleStatusItemProps> = ({ name, type, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <SingleStatusItem isLast={isLast} type={type} className={'completed_status ' + isLastClassName} name={name} {...rest}>
            <div className='flex items-center single_status_item_text'>
                <TwinIcon icon={faCheckCircle} className='text-green-43 mr-5' />
                <span>{name}</span>
            </div>
            {!isLast ?
                <TwinIcon className={'arrow_right ' + type} icon={faChevronRight} />
                : null
            }
        </SingleStatusItem>
    )
}

const SingleStatusItemCompletedCanceled: React.FC<SingleStatusItemProps> = ({ name, type, isLast, ...rest }) => {
    const isLastClassName = isLast ? 'is_last' : ''
    return (
        <SingleStatusItem isLast={isLast} type={type} className={'completed_status ' + isLastClassName} name={name} {...rest}>
            <div className='flex items-center single_status_item_text'>
                <div className='mr-5 rounded-full w-10 h-10 bg-gray-97'></div>
                <span className='text-gray-97'>{name}</span>
            </div>
            {!isLast ?
                <TwinIcon className={'arrow_right ' + type} icon={faChevronRight} />
                : null
            }
        </SingleStatusItem>
    )
}

const SingleStatusItemActualLastCanceled: React.FC<SingleStatusItemProps> = ({ name, ...rest }) => {
    return (
        <SingleStatusItem className='last_actual_status' name={name} {...rest}>
            <div className='flex items-center single_status_item_text'>
                <TwinIcon icon={faXmarkCircle} className='mr-5' />
                <span>{name}</span>
            </div>
        </SingleStatusItem>
    )
}

const SingleStatusItemLastVersion: React.FC<SingleStatusItemProps> = ({ name, ...rest }) => {
    return (
        <SingleStatusItem className={'old_version_status'} name={name} {...rest} >
            <div className='flex items-center single_status_item_text'>
                <div className='mr-5 rounded-full w-10 h-10 bg-gray-97'></div>
                <span className='text-gray-97'><TwinTrans transKey='oldVersion'>Versión antigua</TwinTrans></span>
            </div>
        </SingleStatusItem>
    )
}

const Components: TwinDictionary = {
    completed_status: SingleStatusItemCompleted,
    actual_status: SingleStatusItemActual,
    future_status: SingleStatusItemFuture,
    last_actual_status: SingleStatusItemActualLast,
    canceled_completed_status: SingleStatusItemCompletedCanceled,
    canceled_last_actual_status: SingleStatusItemActualLastCanceled,
    old_version: SingleStatusItemLastVersion
}

export default OrderStatusBar